// Define initial state
const initialState = {
    fullName: '',
    userId: '',
    email: '',
    accountStatus: 0,
    image: '',
    phone: ''
  };
  
  // Define action types
  const SET_USER_INFORMATION = 'SET_USER_INFORMATION';
  const REMOVE_USER_INFORMATION = 'REMOVE_USER_INFORMATION';
  
  // Define reducer function
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_USER_INFORMATION:
        return {
          ...state,
          fullName: action.payload.fullName,
          userId: action.payload.id,
          email: action.payload.email,
          accountStatus: action.payload.accountStatus,
          tncStatus: action.payload.tncStatus,
          image: action.payload.image,
          phone: action.payload.phone
        };
      case REMOVE_USER_INFORMATION:
        return initialState;
      default:
        return state;
    }
  };


// Action creators
const setUserInformation = (fullName, id, email, accountStatus, tncStatus, image, phone) => ({
  type: SET_USER_INFORMATION,
  payload: { fullName, id, email, accountStatus, tncStatus, image, phone }
});

const removeUserInformation = () => ({
  type: REMOVE_USER_INFORMATION
});

export { setUserInformation, removeUserInformation };
export default userReducer;
  